import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={55}
    height={6}
    fill="none"
    {...props}
  >
    <g clipPath="url(#avasdf)">
      <path
        fill="#0FBAB5"
        d="m49 0 2.38 2.8L49 5.62h1.09l4.2-2.82-4.2-2.8H49Z"
      />
    </g>
    <path stroke="#0FBAB5" d="M.5 3h51" />
    <defs>
      <clipPath id="avasdf">
        <path fill="#fff" d="M49 0h5.29v5.62H49z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
